import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.tasks.tasks.general.email,
    (task) => {
        return {
            task
        }
    }
)